import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import style from './style.module.less'
import { dGet } from '@core/utils'
import { isSiDaTeam } from '@util'

@inject('decorationStore')
@observer
export default class extends Component {
  getPath = ({ videoData, videosData, liveData, mode }) => {
    if (isSiDaTeam()) {
      videoData = videosData[0] || {}
      liveData = {}
    }

    const { cover_path, path } = videoData
    const { image_path, video_path } = liveData
    const coverPath = mode === 'preview' ? image_path || cover_path : cover_path
    const videoPath = mode === 'preview' ? video_path || path : path

    return {
      videoPath,
      coverPath
    }
  }

  render() {
    const {
      decorationStore: { videoData, videosData, liveData, promiseData, mode }
    } = this.props

    const { videoPath, coverPath } = this.getPath({
      videoData,
      videosData,
      liveData,
      mode
    })

    const hasPromise =
      (dGet(promiseData, 'privilege.merchant_promise', []) || []).length ||
      (dGet(promiseData, 'privilege.charge_back', []) || []).length

    return videoPath ? (
      <div className={style.content}>
        <img
          className={
            mode === 'preview' && !hasPromise
              ? style.imgWithoutPromise
              : style.img
          }
          src={coverPath}
        />
        <img
          className={style.icon}
          src="//qnm.hunliji.com/o_1cnbhtmk6iu515pf1drl1v991aqa9.png"
        />
      </div>
    ) : (
      <div className={style.imgBlock} />
    )
  }
}
